/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_AlternativesInputs */

const en_directory_footer_link_alternatives = /** @type {(inputs: Directory_Footer_Link_AlternativesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternatives`)
};

const zh_directory_footer_link_alternatives = /** @type {(inputs: Directory_Footer_Link_AlternativesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`替代方案`)
};

/**
* | output |
* | --- |
* | "Alternatives" |
*
* @param {Directory_Footer_Link_AlternativesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_alternatives = /** @type {((inputs?: Directory_Footer_Link_AlternativesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_AlternativesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_alternatives(inputs)
	return zh_directory_footer_link_alternatives(inputs)
});
export { directory_footer_link_alternatives as "directory.footer.link_alternatives" }